import React from "react";
import GATSBY_COMPILED_MDX from "/Users/zuyetawarmatik/git/zuyetawarmatrip/src/pages/trips/2015-may-meteora-greece/index.en.mdx";
import PropTypes from 'prop-types';
import {graphql} from 'gatsby';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import {getImage, GatsbyImage} from 'gatsby-plugin-image';
import {useTranslation, Trans, useI18next} from 'gatsby-plugin-react-i18next';
import {DiscussionEmbed} from 'disqus-react';
import {MDXProvider} from '@mdx-js/react';
import {useFormattedDateLong, useFormattedDateShort} from 'helpers';
import {useSiteMetadata} from 'hooks';
import {BaseLayout} from 'components/Layouts';
import Seo from 'components/Seo';
import PostNavLink from 'components/PostNavLink';
import GbiBridged from 'components/GbiBridged';
import FacebookShareButton from 'components/FacebookShareButton';
import FlickrButton from 'components/FlickrButton';
import BookButton from 'components/BookButton';
import CarbonAds from 'components/CarbonAds';
import Song from 'components/Song';
import {titleWrapperStyle, titleStyle, infoStyle, countryStyle, flagStyle, subtitleStyle, mainImageWrapperStyle, mainImageStyle, mainImageInfoStyle, mainImageInfoBackdropStyle, mainImageInfoContentStyle, mainImageTitleStyle, postContentStyle, disqusStyle, disqusTitleStyle, bookStyle, bookCoverStyle, bookInfoStyle, bookTitleStyle, bookMarketplaceStyle, bookBtnStyle, footerStyle, flickrBtnStyle, seriesStyle, prevNextNavStyle, dirStyle} from './blog-post.styles';
const shortcodes = {
  Alert,
  AlertTitle
};
function BlogPostTemplate(props) {
  const {data, pageContext, children} = props;
  const {language} = useI18next();
  const {t} = useTranslation();
  const {mainImage} = data.post.frontmatter;
  const {title, subtitle, date, arrivalDate, location, countryCode, mainImageTitle, mainImageSubtitle, flickrAlbum, book, song, songId, songArtist, songSubtitle, songType} = pageContext.frontmatter;
  const {author, siteUrl, fbAppId, fbAccessToken} = useSiteMetadata();
  const {previous, next, i18n} = pageContext;
  const url = `${siteUrl}${i18n.path}`;
  const disqusConfig = {
    identifier: pageContext.id,
    url,
    title,
    language
  };
  const country = t(`countries.${countryCode}`);
  const writtenDate = useFormattedDateLong(date);
  const arrivalMonth = useFormattedDateShort(arrivalDate);
  return React.createElement(React.Fragment, null, React.createElement(BaseLayout, null, React.createElement("div", null, React.createElement(Box, {
    sx: titleWrapperStyle
  }, React.createElement(Typography, {
    component: "h1",
    sx: titleStyle
  }, location), React.createElement(Typography, {
    component: "div",
    sx: infoStyle
  }, React.createElement("span", null, arrivalMonth), React.createElement("span", null, "•"), React.createElement(Box, {
    component: "span",
    sx: countryStyle
  }, country, React.createElement(Box, {
    component: "span",
    className: `fi fi-${countryCode}`,
    sx: flagStyle
  }))), React.createElement(Typography, {
    variant: "body1",
    sx: subtitleStyle
  }, subtitle)), React.createElement(Box, {
    sx: mainImageWrapperStyle
  }, React.createElement(Box, {
    component: GbiBridged,
    image: mainImage,
    sx: mainImageStyle
  }, React.createElement(Box, {
    sx: mainImageInfoStyle
  }, React.createElement(Box, {
    sx: mainImageInfoBackdropStyle
  }), React.createElement(Box, {
    sx: mainImageInfoContentStyle
  }, React.createElement(Typography, {
    gutterBottom: true,
    variant: "h5",
    component: "h3",
    sx: mainImageTitleStyle
  }, mainImageTitle), React.createElement(Typography, {
    variant: "body1"
  }, mainImageSubtitle)))))), React.createElement(CarbonAds), React.createElement(Box, {
    sx: postContentStyle
  }, React.createElement(MDXProvider, {
    components: shortcodes
  }, children)), React.createElement(Box, {
    sx: disqusStyle
  }, React.createElement(Typography, {
    align: "center",
    variant: "h6",
    component: "h2",
    sx: disqusTitleStyle
  }, t('comments.header')), React.createElement(DiscussionEmbed, {
    shortname: "https-www-zuyetawarmatrip-com",
    config: disqusConfig
  })), book && React.createElement(Box, {
    sx: bookStyle
  }, React.createElement(Box, {
    component: GatsbyImage,
    image: getImage(data.allFile.nodes.find(file => file.name === book)),
    alt: "book cover",
    sx: bookCoverStyle
  }), React.createElement(Box, {
    sx: bookInfoStyle
  }, React.createElement(Typography, {
    variant: "body2",
    sx: bookTitleStyle
  }, book), React.createElement(Typography, {
    variant: "overline",
    component: "div",
    sx: bookMarketplaceStyle
  }, t('postBook.on', {
    platform: 'Blurb'
  })), React.createElement(BookButton, {
    book: book,
    sx: bookBtnStyle
  }))), React.createElement(Box, {
    sx: footerStyle
  }, React.createElement(FacebookShareButton, {
    url: url,
    appId: fbAppId,
    accessToken: fbAccessToken
  }), React.createElement(FlickrButton, {
    flickrAlbum: flickrAlbum,
    sx: flickrBtnStyle
  }), React.createElement(Typography, {
    variant: "body1",
    sx: seriesStyle
  }, React.createElement(Trans, {
    i18nKey: "postFooter.series",
    values: {
      country
    },
    components: {
      b: React.createElement("strong")
    }
  })), React.createElement(Typography, {
    variant: "overline",
    component: "div"
  }, React.createElement(Trans, {
    i18nKey: "postFooter.writtenDate",
    values: {
      date: writtenDate,
      author
    }
  }))), React.createElement(Box, {
    sx: prevNextNavStyle
  }, React.createElement(Box, {
    sx: dirStyle
  }, React.createElement(PostNavLink, {
    post: previous
  })), React.createElement(Box, {
    sx: dirStyle
  }, React.createElement(PostNavLink, {
    post: next,
    next: true
  })))), song && React.createElement(Song, {
    song: song,
    songId: songId,
    songArtist: songArtist,
    songSubtitle: songSubtitle,
    songType: songType
  }));
}
const {shape} = PropTypes;
BlogPostTemplate.propTypes = {
  data: shape({}),
  pageContext: shape({})
};
BlogPostTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(BlogPostTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const pageQuery = graphql`
  query ($id: String!, $language: String!) {
    locales: allLocale(filter: { ns: { in: ["common"] }, language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    post: mdx(id: { eq: $id }) {
      frontmatter {
        mainImage {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH, quality: 85)
          }
        }
        fbImage: mainImage {
          childImageSharp {
            gatsbyImageData(layout: FIXED, width: 1200, height: 630, quality: 80, formats: [JPG])
          }
        }
      }
    }
    allFile(filter: { sourceInstanceName: { eq: "static" }, relativeDirectory: { eq: "books" } }) {
      nodes {
        name
        childImageSharp {
          gatsbyImageData(width: 200, quality: 80)
        }
      }
    }
  }
`;
export function Head(props) {
  return React.createElement(Seo, props);
}
